<template>
  <div class="tw-pl-2 tw-pr-4">
    <div class="tw-pb-2">
      <InputGroup
        label="Update Name"
        name="name"
        type="text"
        placeholder="name"
        v-model="name"
        :error="nameError"
      />
    </div>
    <div class="tw-flex tw-items-center tw-justify-end">
      <BaseButton
        text="Cancel"
        class="tw-border-0 tw-bg-app-black-11"
        @click="cancelEditing"
        :disabled="savingName"
      />
      <BaseButton
        text="Save"
        class="tw-border-0 tw-bg-black tw-text-white tw-ml-2"
        @click="saveProgramName"
        :disabled="savingName"
      />
    </div>
  </div>
</template>

<script>
import InputGroup from '@/components/InputGroup.vue';
import form from '@/modules/formHelper';

export default {
  name: 'EditCompanyProgramName',
  components: {
    InputGroup,
  },
  props: {
    companyProgram: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      name: this.companyProgram.name,
      nameError: undefined,
      savingName: false,
    };
  },
  methods: {
    cancelEditing() {
      this.$emit('cancel-editing');
    },
    async saveProgramName() {
      if (!form.isValidTextInput(this.name)) return;

      this.savingName = true;

      const formData = {
        progid: this.companyProgram.id,
        name: this.name,
      };

      const response = await this.$store.dispatch('editProgramName', formData);

      if (!response) {
        this.$toasted.global.appError({ errorMessage: 'Could not save new program name' });
      } else {
        this.$toasted.success('Program name saved', {
          duration: 3500,
          position: 'top-right',
        });

        this.$emit('name-saved');
      }

      this.savingName = false;
    },
  },
};
</script>

<style>

</style>
